import React from 'react';
import { StyleSheet, View } from 'react-native';
import { HiveSize, HiveSubscriptionType } from '../../constants/constants';
import { HivePurchaseCard } from '../screens/CreateHive/HivePurchaseCard';

export const HIVES = {
  [HiveSize.SingleUser]: {
    colors: ['#FFCF53', '#FF9900'],
    name: 'Single Hive',
    description: 'Perfect for playing online or inviting a friend',
    prices: {
      [HiveSubscriptionType.month]: '0.99',
    },
    features: [
      'Powerful game based learning',
      'Assessment re-imagined',
      'Individual learning journeys',
      'Access ALL game boards',
      'Enhanced reporting features',
      'Math mindset skills assessment',
      'Admin plus 1 seat',
    ],
    capacity: 1,
  },
  [HiveSize.FamilyHive]: {
    colors: ['#FF9252', '#FF3F15'],
    name: 'Group hive',
    description: 'Perfect for families, homeschoolers, tutoring or small class groups',
    prices: {
      [HiveSubscriptionType.month]: '4.99',
      [HiveSubscriptionType.year]: '29.99',
    },
    features: [
      'Powerful game based learning',
      'Assessment re-imagined',
      'Individual learning journeys',
      'Access ALL game boards',
      'Enhanced reporting features',
      'Math mindset skills assessment',
      'Admin plus 7 seats',
    ],
    capacity: 7,
  },
  [HiveSize.ClassHive]: {
    colors: ['#90DF75', '#62B655'],
    name: 'Class hive',
    description: 'Perfect for primary and high school teachers',
    prices: {
      [HiveSubscriptionType.month]: '7.99',
      [HiveSubscriptionType.year]: '69.99',
    },
    features: [
      'Powerful game based learning',
      'Assessment re-imagined',
      'Individual learning journeys',
      'Access ALL game boards',
      'Enhanced reporting features',
      'Math mindset skills assessment',
      'Admin plus 40 seats',
    ],
    capacity: 40,
  },
  [HiveSize.SchoolHive]: {
    colors: ['#4A90E2', '#0071BC'],
    name: 'School hive',
    description: 'Perfect for primary and high school teachers',
    capacity: '5000',
    prices: {
      [HiveSubscriptionType.year]: '299.99',
    },
    features: [
      'Powerful game based learning',
      'Assessment re-imagined',
      'Individual learning journeys',
      'Access ALL game boards',
      'Enhanced reporting features',
      'Math mindset skills assessment',
      '14 days trial available',
      'Unlimited class hives',
    ],
  },
};

type PremiumPlansProps = {
  subscriptionType?: HiveSubscriptionType;
  onSelectHive?: (hiveSize: HiveSize) => void;
};

const PremiumPlans = ({ subscriptionType, onSelectHive }: PremiumPlansProps) => {
  return (
    <View style={styles.premiumPlansRow}>
      <HivePurchaseCard
        colors={HIVES.SingleUser.colors}
        name={HIVES.SingleUser.name}
        description={HIVES.SingleUser.description}
        prices={HIVES.SingleUser.prices}
        subscriptionType={subscriptionType}
        features={HIVES.SingleUser.features}
        onPress={() => onSelectHive?.(HiveSize.SingleUser)}
      />
      <HivePurchaseCard
        colors={HIVES.FamilyHive.colors}
        name={HIVES.FamilyHive.name}
        description={HIVES.FamilyHive.description}
        prices={HIVES.FamilyHive.prices}
        subscriptionType={subscriptionType}
        features={HIVES.FamilyHive.features}
        onPress={() => onSelectHive?.(HiveSize.FamilyHive)}
      />
      <HivePurchaseCard
        colors={HIVES.ClassHive.colors}
        name={HIVES.ClassHive.name}
        description={HIVES.ClassHive.description}
        prices={HIVES.ClassHive.prices}
        subscriptionType={subscriptionType}
        features={HIVES.ClassHive.features}
        onPress={() => onSelectHive?.(HiveSize.ClassHive)}
      />
      <HivePurchaseCard
        colors={HIVES.SchoolHive.colors}
        name={HIVES.SchoolHive.name}
        description={HIVES.SchoolHive.description}
        prices={HIVES.SchoolHive.prices}
        subscriptionType={subscriptionType}
        features={HIVES.SchoolHive.features}
        contactUs
      />
    </View>
  );
};

export { PremiumPlans };

const styles = StyleSheet.create({
  premiumPlansRow: {
    flexDirection: 'row',
    gap: 17,
  },
  responsivePremiumColumn: {
    flexDirection: 'column',
  },
  centeredCard: {
    marginHorizontal: 17,
  },
  middleCard: {
    marginVertical: 17,
  },
});
